/**
 * ActiveAlertsTab Component
 *
 * Wrapper component for the Active Alerts tab content.
 */

import React from 'react';

import { ActiveAlertsTabContent } from '../index';
import {
  useMonitoringShared,
  useMonitoringSearch,
  useMonitoringAlertsTab,
} from '../../../contexts/MonitoringCenterContext';

/**
 * Active Alerts tab content wrapper
 */
export function ActiveAlertsTab() {
  const shared = useMonitoringShared();
  const search = useMonitoringSearch();
  const alertsTab = useMonitoringAlertsTab();

  return (
    <ActiveAlertsTabContent
      filteredAlerts={alertsTab.filteredAlerts}
      activeAlertsCount={alertsTab.activeAlertsCount}
      searchQuery={search.searchQuery}
      appliedAlertFilters={alertsTab.appliedAlertFilters}
      dismissingAlerts={alertsTab.dismissingAlerts}
      resolvingAlerts={alertsTab.resolvingAlerts}
      notifyingAlerts={alertsTab.notifyingAlerts}
      onResolve={alertsTab.onResolve}
      onDismiss={alertsTab.onDismiss}
      onNotify={alertsTab.onNotify}
      onRowClick={alertsTab.onAlertClick}
      hasTestData={shared.hasTestData}
      hasNotificationChannels={alertsTab.hasNotificationChannels}
      onClearAllFilters={alertsTab.onAlertFiltersClearAll}
      onPopulateTestData={alertsTab.onPopulateTestData}
      isGeneratingTestData={alertsTab.isGeneratingTestData}
    />
  );
}
